export default __webpack_public_path__ + "static/media/page_feature_disabled.a7c403a2.png";